<script>
import validateParamsObject from '../utils/validations/UIParameters';

export default {
  watch: {
    '$route.hash': function () {
      this.getRouteHashParams();
    },
  },
  created() {
    this.getRouteHashParams();
  },
  methods: {
    // Get route hash params to customize UI
    getRouteHashParams() {
      const paramsObj = {};
      if (this.$route.hash) {
        this.$route.hash
          .split('&')
          .map((part) => part.replace(/#/, ''))
          .forEach((param) => {
            const parts = param.split('=');
            paramsObj[parts[0]] = parts[1];
          });
        const validObject = validateParamsObject(paramsObj);
        if (Object.entries(validObject).length) this.$store.commit('setUIParametersObj', validObject);
      }
    },
  },
};
</script>
